import * as classNames from "classnames";
import * as React from 'react';
import { withTheme } from '../../common/withTheme';
import Loader from "react-loaders";
import HasRole from "../Auth/HasRole";

export interface IContentTab {
    component: any;
    componentProps?: any;
    dataReady: boolean;
    labelIcon?: string;
    label: string;
    role?: string;
    title?: string;
}

interface IContentTabsProps {
    labelLoading: string;
    label404: string;
    loading: boolean;
    tabs: IContentTab[];
}

interface IContentTabsActions {
}

type ContentTabsPropsAndActions = IContentTabsProps & IContentTabsActions;

type ContentTabsState = {
    activeTab: number
}

class ContentTabs extends React.PureComponent<ContentTabsPropsAndActions, ContentTabsState> {
    constructor(props, context) {
        super(props, context);

        this.state = { activeTab: 0 }
        this.onSetTab = this.onSetTab.bind(this);
    }

    onSetTab(tabId) {
        this.setState({ activeTab: tabId });
    }

    render() {

        const { labelLoading, label404, loading, tabs } = this.props;

        const Component = tabs[this.state.activeTab].component;
        const TabTitle = tabs[this.state.activeTab].title;

        return (
            <>
                <ul className="nav nav-tabs plot-tabs">
                    {
                        tabs.map((tab, i) => <HasRole role={tab.role} key={tab.label}>
                            <li className="nav-item">
                                <button className={classNames("nav-link clickable", { "active": this.state.activeTab === i })} onClick={this.onSetTab.bind(this, i)}>
                                    {tab.labelIcon ? <i className={classNames("pr-2 fa", tab.labelIcon)} /> : null}
                                    {tab.label}
                                </button>
                            </li>
                        </HasRole>
                        )
                    }
                </ul>
                {
                    loading
                        ? <div className="position-absolute" style={{ bottom: '50%', left: '42%' }}>
                            <Loader type="ball-scale-multiple" active />
                            <div className="ml-4 small">{labelLoading}</div>
                        </div>
                        : tabs[this.state.activeTab].dataReady
                            ? <>
                                {this.props.children}
                                {TabTitle ? <h3 className="col-12 border-bottom my-2 pb-2">{TabTitle}</h3> : null}
                                {Component}
                            </>
                            :  <h2 className="text-center mt-5">{label404}</h2>

                }
            </>
        );
    }
}

export default withTheme<ContentTabsPropsAndActions>(ContentTabs);